import { TicketSummaryDTO } from '../models/order';
import { formatCurrency } from '../utils/shared';
import FilterTable, { BaseData } from './Table/Table';

interface Props {
  summaries: TicketSummaryDTO[];
}

interface TableRows extends BaseData {
  id: string;
  ticket_name: string | JSX.Element;
  ticket_price: string | JSX.Element;
  amount: number;
  total: string | JSX.Element;
  count_manual: number;
  count_online: number;
  total_manual: string | JSX.Element;
  total_online: string | JSX.Element;
}

const TicketsSummaryTable: React.FC<Props> = ({ summaries }) => {
  const rows: TableRows[] = summaries.map((summary) => ({
    id: summary.ticket_id,
    ticket_name: summary.ticket_name,
    ticket_price: <div className='whitespace-nowrap'>{formatCurrency(summary.ticket_price)}</div>,
    amount: summary.count,
    total: <div className='whitespace-nowrap'>{formatCurrency(summary.total)}</div>,
    count_manual: summary.count_manual,
    count_online: summary.count_online,
    total_manual: <div className='whitespace-nowrap'>{formatCurrency(summary.total_manual)}</div>,
    total_online: <div className='whitespace-nowrap'>{formatCurrency(summary.total_online)}</div>,
    scanned: summary.scanned,
  }));

  const config = [
    {
      id: 'ticket_name',
      label: 'Ticket',
    },
    {
      id: 'ticket_price',
      label: 'Precio',
    },

    {
      id: 'amount',
      label: 'Cantidad',
    },
    {
      id: 'total',
      label: 'Total',
    },
    {
      id: 'count_manual',
      label: 'Cantidad venta manual',
    },
    {
      id: 'scanned',
      label: 'QR escaneados',
    },
    {
      id: 'count_online',
      label: 'Cantidad venta online',
    },
    {
      id: 'total_manual',
      label: 'Total venta manual',
    },
    {
      id: 'total_online',
      label: 'Total venta online',
    },
  ];

  return (
    <div>
      {summaries.length > 0 ? (
        <FilterTable
          rows={rows}
          headCells={config}
          pagination={{ enabled: false }}
          searchEnabled={false}
          tableId="sellers-ticket-summary-table"
        />
      ) : (
        <div className='flex flex-col gap-2 items-center justify-center h-full glass-surface'>
          <h1 className='text-lg font-medium text-center'>No hay resumen de entradas</h1>
        </div>
      )}
    </div>

  );
};

export default TicketsSummaryTable;
